import * as requestFromServer from "./ModulesCrud";
import { moduleSlice, callTypes } from "./ModulesSlice";

const {actions} = moduleSlice;

export const getAsideMenuList = () => async dispatch => {
  return requestFromServer
    .getAsideMenuList()
    .then(response => {
      if (response.data.isSuccess !== false) dispatch(actions.asideMenuFetched(response.data));      
    })
    .catch(error => {
      
    });
};

export const getModules = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getModules()
    .then(response => {
      dispatch(actions.modulesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getModule = id => async dispatch => {
  if (!id) {
    return dispatch(actions.moduleFetched(undefined));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getModule(id)
    .then(response => {
      dispatch(actions.moduleFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveModule = module => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveModule(module)
    .then(response => {
      dispatch(actions.moduleSaved());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanAsideMenuList = () => dispatch => {
  dispatch(actions.asideMenuListCleaned());
}

export const cleanModulesState = () => dispatch => {
  dispatch(actions.modulesStateCleaned());
}